// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1k5NS","inner":"Form_inner__23Hx_","range":"Form_range__1qkv_","name":"Form_name__1z87P","actions":"Form_actions__28NNS"};